import { useRef } from "react";
import { Helmet } from "react-helmet";
import LandingNav from "../components/landing/LandingNav";
import Hero from "../components/landing/Hero";
import Marquee from "../components/landing/Marquee";
import Steps from "../components/landing/Steps";
import Features from "../components/landing/Features";
import Pricing from "../components/landing/Pricing";
import LandingFAQ from "../components/landing/LandingFAQ";
import FinalCta from "../components/landing/FinalCta";
import LandingFooter from "../components/landing/LandingFooter";
import useLandingMotion from "../components/landing/useLandingMotion";
import Seo, { SITE_NAME, DEFAULT_DESCRIPTION } from "../components/Seo";
import { MENU_BASE_URL } from "../menu.js";
import { FREE_PRODUCT_LIMIT, PRO_PRICE, PRO_TRIAL_DAYS } from "../plans";
import useLandingTheme from "../components/landing/useLandingTheme";
import "../landing.css";

// Datos estructurados de la marca y la app, para los resultados de Google.
const homeJsonLd = {
    "@context": "https://schema.org",
    "@graph": [
        {
            "@type": "Organization",
            "@id": MENU_BASE_URL + "/#organization",
            name: SITE_NAME,
            url: MENU_BASE_URL + "/",
            logo: MENU_BASE_URL + "/icon-512.png",
            email: "contacto@miqrapp.com",
            sameAs: ["https://www.instagram.com/miqrapp"]
        },
        {
            "@type": "WebSite",
            "@id": MENU_BASE_URL + "/#website",
            name: SITE_NAME,
            url: MENU_BASE_URL + "/",
            inLanguage: "es-AR",
            publisher: { "@id": MENU_BASE_URL + "/#organization" }
        },
        {
            "@type": "SoftwareApplication",
            name: SITE_NAME,
            url: MENU_BASE_URL + "/",
            description: DEFAULT_DESCRIPTION,
            applicationCategory: "BusinessApplication",
            operatingSystem: "Web",
            inLanguage: "es-AR",
            publisher: { "@id": MENU_BASE_URL + "/#organization" },
            offers: [
                {
                    "@type": "Offer",
                    name: "Gratis",
                    price: "0",
                    priceCurrency: "ARS",
                    description: `Menú o catálogo con QR y hasta ${FREE_PRODUCT_LIMIT} productos.`
                },
                {
                    "@type": "Offer",
                    name: "Pro",
                    price: PRO_PRICE.replace(/\D/g, ""),
                    priceCurrency: "ARS",
                    description: `Productos ilimitados y sin la marca de MiQRapp. ${PRO_TRIAL_DAYS} días de prueba gratis, después se cobra por mes.`
                }
            ]
        }
    ]
};

const Home = () => {

    const rootRef = useRef(null);
    const { dark, toggleTheme } = useLandingTheme();

    useLandingMotion(rootRef);

  return (
    <div className="lp" data-theme={dark ? "dark" : "light"} ref={rootRef}>
        <Seo title="MiQRapp - Tu menú o catálogo online con QR" path="/" jsonLd={homeJsonLd}></Seo>
        <Helmet>
            <body className={dark ? "lp-body lp-body-dark" : "lp-body"} />
            <meta name="theme-color" content={dark ? "#120b14" : "#fbfaf7"} />
        </Helmet>

        <LandingNav dark={dark} onToggleTheme={toggleTheme}></LandingNav>
        <main>
            <Hero></Hero>
            <Marquee></Marquee>
            <Steps></Steps>
            <Features></Features>
            <Pricing></Pricing>
            <LandingFAQ></LandingFAQ>
            <FinalCta></FinalCta>
        </main>
        <LandingFooter></LandingFooter>
    </div>
  )
}

export default Home
